export default __webpack_public_path__ + "static/erika-028e336dfe0db5526c91bf38efe04ced.jpeg";